import React from 'react'
import clsx from 'clsx'

export default function Divider({ className }) {
  return <div className={clsx('border-t border-gray-200', className || 'my-1')} />
}
